import { useSubscription } from '@apollo/client';

import { RecommendationGenerationUpdatesDocument } from '@/modules/common/types';

export const useRecommendationGenerationUpdates = () => {
  useSubscription(RecommendationGenerationUpdatesDocument, {
    onData: ({ client, data }) => {
      if (!data.data || data.loading || data.error) return;

      const update = data.data.recommendationGenerationUpdates;

      if (update.dataPoint) {
        const dataPoint = update.dataPoint;

        client.cache.modify({
          id: client.cache.identify({ __typename: 'DataPoint', id: dataPoint.id }),
          fields: {
            title: () => dataPoint.title,
            suggestionGenerationStatus: () => dataPoint.suggestionGenerationStatus,
            recommendationGenerationStatus: () => dataPoint.recommendationGenerationStatus,
            recommendation: () => dataPoint.recommendation ?? null,
            incomingSuggestions: () => dataPoint.incomingSuggestions,
          },
        });
      }

      if (update.documentFormField) {
        const documentFormField = update.documentFormField;

        client.cache.modify({
          id: client.cache.identify({
            __typename: 'DocumentFormField',
            id: documentFormField.id,
          }),
          fields: {
            name: () => documentFormField.name,
            type: () => documentFormField.type,
            suggestionGenerationStatus: () => documentFormField.suggestionGenerationStatus,
            recommendationGenerationStatus: () => documentFormField.recommendationGenerationStatus,
            recommendation: () => documentFormField.recommendation ?? null,
            suggestions: () => documentFormField.suggestions,
            widgets: (existing) => documentFormField.widgets ?? existing,
          },
        });
      }
    },
  });
};
